import React from "react";

const JustLawProject = () => {
  const capsules = [
    { label: "🚀 Deployed", color: "#07ae18ff", bg: "rgba(24,198,41,0.1)" },
    { label: "🤝 Client: JustLaw", color: "#444", bg: "rgba(0,0,0,0.05)" },
    { label: "🔗 Link: https://justlaw.am", color: "#d63384", bg: "rgba(214,51,132,0.08)" }
  ];

  const sections = [
    {
      title: "✨ About the Project",
      description:
        "JustLaw.am is a clean and straightforward single-page application designed to present legal services in a simple and professional way. The focus was on clarity, fast navigation, and mobile responsiveness.",
    },
    {
      title: "⚙️ My Role",
      description:
        "I designed and developed the website from scratch, handling both UI/UX and implementation in React.js. The aim was to deliver a modern yet lightweight site for quick client access.",
    },
    {
      title: "🖥️ Tech Stack",
      description:
        "Frontend: React.js (SPA). Deployment: Static hosting on AWS amplify. As Simple As That.",
    },
  ];

  return (
    <section
      style={{
        padding: "100px 20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1200px",
          margin: "0 auto",
          gap: "60px",
        }}
      >
        {/* Left Side */}
        <div style={{ flex: "1 1 500px", minWidth: "320px" }}>
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "24px",
              color: "#2b213b",
              lineHeight: "1.2",
              fontFamily: "Inter",
            }}
          >
            FIRST PAID PROJECT •{" "}
            <span style={{ color: "#db2254", fontFamily: "Inter" }}>
              JustLaw.am Website
            </span>
          </h2>

          {/* Capsules */}
          {/* <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              marginBottom: "28px",
            }}
          >
            {capsules.map((cap, idx) => (
              <span
                key={idx}
                style={{
                  padding: "6px 14px",
                  border: `1px solid ${cap.color}`,
                  borderRadius: "999px",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  color: cap.color,
                  backgroundColor: cap.bg,
                  whiteSpace: "nowrap",
                }}
              >
                {cap.label}
              </span>
            ))}
          </div> */}
{/* Capsules */}
<div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "28px",
  }}
>
  {capsules.map((cap, idx) => (
    <span
      key={idx}
      style={{
        padding: "6px 14px",
        border: `1px solid ${cap.color}`,
        borderRadius: "999px",
        fontSize: "0.9rem",
        fontWeight: "600",
        color: cap.color,
        backgroundColor: cap.bg,
        whiteSpace: "nowrap",
      }}
    >
      {cap.label.startsWith("🔗") ? (
        <a
          href={cap.label.replace(/🔗 Link: /, "")} // get the URL
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: cap.color, textDecoration: "underline" }}
        >
          {cap.label} {/* keeps the label text with emoji */}
        </a>
      ) : (
        cap.label
      )}
    </span>
  ))}
</div>

          {/* Sections */}
          {sections.map((sec, idx) => (
            <div key={idx} style={{ marginBottom: "24px" }}>
              <h3
                style={{
                  fontSize: "1.35rem",
                  fontWeight: "700",
                  marginBottom: "8px",
                  color: "#2b213b",
                }}
              >
                {sec.title}
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#555",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                {sec.description}
              </p>
            </div>
          ))}
        </div>

        {/* Right Side: Preview */}
        <div
          style={{
            flex: "1 1 350px",
            minWidth: "260px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "600px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
            }}
          >
            <VideoShowcase/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JustLawProject;
const VideoShowcase = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Desktop Frame */}
      <div
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
          width: "100%",
          aspectRatio: "16 / 9", // keeps video proportional
          backgroundColor: "#000",
        }}
      >
        <video
          src="https://my-video-assests.s3.eu-north-1.amazonaws.com/jsutlaw.m4v"
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // cover works fine here
          }}
        />
      </div>

      {/* Mobile iPhone Frame Preview */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          right: "20px",
        //   width: "180px",
          height: "70%",
          aspectRatio: "9 / 19",
          borderRadius: "8px",
          border: "3px solid #000000ff",
          overflow: "hidden",
          backgroundColor: "#000", // fallback if video doesn’t fill
          boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <video
          src="https://my-video-assests.s3.eu-north-1.amazonaws.com/justlawmobile.m4v"
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain", // ensures no cropping
          }}
        />
      </div>
    </div>
  );
};